// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const linkClasses = {
  icon: "qui-link__icon",
  root: "qui-link__root",
} as const
